export default __webpack_public_path__ + "static/media/lines.2b1549b3.svg";